import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["status", "quality"];
  static values = { url: String };

  async save() {
    const body = new FormData();
    this.element.querySelectorAll("[data-field]").forEach((input) => {
      body.append(`yard_setting[${input.dataset.field}]`, input.type === "checkbox" ? input.checked : input.value);
    });
    this.statusTarget.textContent = "Saving…";
    this.statusTarget.className = "yard-row__status";

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      body,
      headers: { "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content, Accept: "application/json" }
    });
    const result = await response.json();
    if (response.ok) {
      this.qualityTarget.textContent = result.quality_score ?? "";
      this.statusTarget.textContent = "Saved";
      this.statusTarget.classList.add("yard-row__status--saved");
    } else {
      this.statusTarget.textContent = result.errors.join(", ");
      this.statusTarget.classList.add("yard-row__status--error");
    }
  }
}
